module.exports = __webpack_public_path__ + "img/role-head7.cf047d8f.png";